export default {
  AUTH_TOKEN: "authToken",
  MEMBER_APP_PRIVATE_KEY: "memberAppPrivateKey",
  MEMBER_APP_SIGNING_PUBLIC_KEY: "memberAppSigningPublicKey",
  MEMBER_APP_SIGNING_PRIVATE_KEY: "memberAppSigningPrivateKey",
  APP_ID: "appId",
  ECC_CURVE: "eccCurve",
  ECC_SIGNING_CURVE: "eccSigningCurve",
  APP_SECRET: "appSecret",
  MEMBER_PUBLIC_KEY: "memberPublicKey",
  MEMBER_PRIVATE_KEY: "memberPrivateKey",
  ORG_KEY: "orgKey",
  MEMBER_KEY: "memberKey",
  MEMBER_AUTH_SALT: "memberAuthSalt",
  ORG_MEMBER_ID: "orgMemberId",
  ORG_NAME: "orgName",
  BACKDOOR_PUBLIC_KEY: "backdoorPublicKey",
  BACKDOOR_SIGNING_PUBLIC_KEY: "backdoorSigningPublicKey",
  BACKDOOR_SIGNING_PRIVATE_KEY: "backdoorSigningPrivateKey",
  ORG_ID: "orgId",
  MEMBER_ID: "memberId",
  JOINED_GROUP_KEYS: "joinedGroupKeys",
  UNJOINED_GROUP_KEYS: "unjoinedGroupKeys",
  ORG_SIGNING_PRIVATE_KEY: "orgSigningPrivateKey",
  ORG_SIGNING_PUBLIC_KEY: "orgSigningPublicKey",
  MEMBER_SIGNING_PRIVATE_KEY: "memberSigningPrivateKey",
  MEMBER_SIGNING_PUBLIC_KEY: "memberSigningPublicKey",
  MEMBER_STATUS: "memberStatus",
  USER_AUTH_SALT: "userAuthSalt",
  MEMBER_APP_ID: "memberAppId",
  ANSWER_AUTH_SALT: "authAnswerSalt",
  IS_PASSPHRASE_ACTIVE: "isPassphraseActive",
  USER_PRIVATE_KEY: "userPrivateKey",
  USER_SIGNING_PUBLIC_KEY: "userSigningPublicKey",
  USER_SIGNING_PRIVATE_KEY: "userSigningPrivateKey",
  USER_ID: "userId",
  DEFAULT_ENCRYPTION_POLICY: "defaultEncryptionPolicy",
  DEFAULT_ENCRYPTION_MODE: "defaultEncryptionMode",
  DEFAULT_KEY_GENERATION_POLICY: "defaultKeyGenerationPolicy",
  ADMIN_PUBLIC_KEY: "adminPublicKey",
  MEMBER_APP_PUBLIC_KEY: "memberAppPublicKey",
  CREATION_APP_PUBLIC_KEY: "creationAppPublicKey",
  MEMBER_CREATION_APP_PUBLIC_KEY: "memberCreationAppPublicKey",
  ORG_CREATION_APP_PUBLIC_KEY: "orgCreationAppPublicKey",
  AUTHORIZATION_APP_PUBLIC_KEY: "authorizationAppPublicKey",
  // Both hold the ghost member's SIGNING key: the server publishes
  // ghostMemberKeyDetail.getSigningPublicKey() under the wire name `ghostMemberPublicKey`, and
  // getSignatureVerificationPublicKey resolves GhostMemberPublicKeyTag to it to verify signatures.
  // The stored string keys keep the old spelling so existing sessions still read; only the
  // constant names change, because a name saying "encryption key" over a signing key is how a
  // verify-with-the-wrong-key bug gets written.
  GHOST_MEMBER_SIGNING_PUBLIC_KEY: "ghostMemberPublicKey",
  GHOST_MEMBER_SIGNING_PUBLIC_KEY_WITH_SIGNATURES: "ghostMemberPublicKeyWithSignatures",
  USER_PUBLIC_KEY: "userPublicKey",
  APP_SECRET_SALT: "appSecretSalt",
  APP_KEY_PAIR_ID: "appKeyPairId",
  ACCESS_APP_SIGNING_PUBLIC_KEY: "accessAppSigningPublicKey",
  ACCESS_APP_SIGNING_PRIVATE_KEY: "accessAppSigningPrivateKey",
  MEMBER_CREATION_APP_SIGNING_PUBLIC_KEY: "memberCreationAppSigningPublicKey",
  MEMBER_CREATION_APP_SIGNING_PRIVATE_KEY: "memberCreationAppSigningPrivateKey",
  ORG_CREATION_APP_SIGNING_PUBLIC_KEY: "orgCreationAppSigningPublicKey",
  ORG_CREATION_APP_SIGNING_PRIVATE_KEY: "orgCreationAppSigningPrivateKey",
  AUTHORISATION_APP_SIGNING_PUBLIC_KEY: "authorizationAppSigningPublicKey",
  AUTHORISATION_APP_SIGNING_PRIVATE_KEY: "authorizationAppSigningPrivateKey",
  ACCESS_APP_PRIVATE_KEY: "accessAppPrivateKey",
  ACCESS_APP_KEY_PAIR_ID: "accessAppPrivateKeyPairId",
  MEMBER_CREATION_APP_PRIVATE_KEY: "memberCreationAppPrivateKey",
  MEMBER_CREATION_APP_KEY_PAIR_ID: "memberCreationAppPrivateKeyPairId",
  ORG_CREATION_APP_PRIVATE_KEY: "orgCreationAppPrivateKey",
  ORG_CREATION_APP_KEY_PAIR_ID: "orgCreationAppPrivateKeyPairId",
  AUTHORISATION_APP_PRIVATE_KEY: "authorizationAppPrivateKey",
  AUTHORISATION_APP_KEY_PAIR_ID: "authorizationAppPrivateKeyPairId",
  GHOST_MEMBER_ID: "ghostMemberId",
  IS_TWO_FA_ENABLED: "isTwoFaEnabled",
  HALF_SIGNED_MEMBER_PUBLIC_KEY: "halfSignedMemberPublicKey",
  ENCRYPTION_TYPE: "encryptionType",
  IS_CREATE_ORG_REQUEST: "isCreateOrgRequest",
  IS_VALIDATE_2FA_FOR_CREATE_MEMBER_APP: "isValidate2FAForCreateMemberApp",
  IS_VALIDATE_2FA_FOR_CREATE_MEMBER: "isValidate2FAForCreateMember",
  EMAIL_ADDRESS: "emailId",
  DECRYPTED_CHALLENGE: "decryptedChallenge",
  IS_ENCRYPTION_ENABLED: "isEncryptionEnabled",
  LAST_CHAIN_OBJECT_FOR: "lastChainObjectFor",
  CHAIN_KGP_OBJECTS_LIST: "chainKgpObjectsList",
  STATS_SYNC_TIME_DURATION: "statsSyncTimeDuration",
  STATS_SYNC_EXPIRY_TIME: "statsSyncExpiryTime",
  STATISTICS_KEY: "statisticsKey",
  ENCRYPTION_COUNT: "encryptionCount",
  DECRYPTION_COUNT: "decryptionCount",
  LOCAL_STORAGE_ENCRYPTION_KEY: "localStorageEncryptionKey",
  LOCAL_STORAGE_ENCRYPTION_HASH: "localStorageEncryptionHash",
  AUTHENTICATION_SALT: "authenticationSalt",
  LOCAL_STORAGE_ENCRYPTION_MODE: "localStorageEncryptionMode",
  IS_NEW_AUTHENTICATION: "isNewAuthentication",
  MFA_SETTING: "mfaSetting",
  SECURITY_QUESTIONS: "securityQuestions",
  LAST_LOGIN_TIME: "lastLoginTime",
  ENCRYPTED_USER_PRIVATE_KEY_PARTS: "encryptedUserPrivateKeyParts",
  ANSWER_KEY_SALTS: "answerKeySalts",
  LOCAL_ENCRYPTION_VERIFICATION_STRING: "localEncryptionVerificationString",
  IS_APP_CREATED_WITH_PWD: "isAppCreatedWithPasscode",
  ENABLE_FACE_RECOGNITION: "enableFaceRecognition",
  FR_ENCRYPTION_KEY: "frEncryptionKey",
  FR_DECRYPTION_KEY: "frDecryptionKey",
  REGISTER_FACE_ID: "registerFaceId",
  VISHWAM_SECRET: "vishwamSecret",
  AUTH_PASSCODE_KEY: "authPasscodeKey",
  MEMBER_KEY_SALT: "memberKeySalt",
  LOCK_UNLOCK_EXPIRY_TIME: "lockAndUnlockExpiryTime",
  GROUP_PUBLIC_KEY: "groupPublicKey",
  MEMBER_APP_STATUS: "appStatus",
  BAYUN_SERVER_PUBLIC_KEY: "bayunServerPublicKey",
  USER_STATUS: "userStatus",
  MULTI_FACTOR_AUTH: "multiFactorAuth",
  IS_PASSCODE_AUTH: "isPasscodeAuth",
  IS_DEVELOPER: "isDeveloper",
  DEVELOPER_KEY: "developerKey",
  DEVELOPER_KEY_KEK: "developerKeyKek",
  IS_USER: "isUser",
  IS_ADMIN: "isAdmin",
  IS_SECURITY_ADMIN: "isSecurityAdmin",
  ADMIN_PRIVATE_KEY_KEK: "adminPrivateKey_kek",
  BACKDOOR_PRIVATE_KEY_PART_KEK: "backdoorPrivateKeyPart_kek",
  ADMIN_PRIVATE_KEY: "adminPrivateKey",
  ADMIN_SIGNING_PUBLIC_KEY: "adminSigningPublicKey",
  ADMIN_SIGNING_PRIVATE_KEY: "adminSigningPrivateKey",
  IS_NEW_USER: "isNewUser",
  LAST_LOGGED_IN_ACCOUNT_TYPE: "lastLoggedInAccountType",
  KEY_VALIDATION_POLICY: "keyValidationPolicy",
  IS_REGISTER_FLOW: "isRegisterFlow",
  RECOVERY_FLOW: "recoveryFlow",
  FIRST_TIME_LOG_IN: "firstTimeLogIn",
  VALIDATION_SECRET_DATA_REQUEST: "validationSecretDataRequest",
  MINIMUM_CORRECT_QUESTIONS: "minimumCorrectQuestions",
  APPLICATION_TYPE: "applicationType",
  ORG_TYPE: "orgType",
  SETTING_LAST_UPDATED_AT: "settingLastUpdatedAt",
};
